import {
	api_methods
} from '../../service/loadData'
import Vue from 'vue'
import util from '@/config/util'
let systemError = {msg:'系统异常，请稍后重试',code:-1};
import {
	SETMETTINGVIPSTORES
} from './mutation-types.js'

export default {
	async getVIPMeetingRoomsAction({ commit,state,getters},params) {
		let response = await api_methods.getVIPMeetingRooms(getters.getAccessToken,getters.getVipNo,params)
		if (response?.response?.code == 1) {
			return response.data.value
		}
		return []
	},
	async getVIPMeetingRoomAction({ commit,state,getters},params) {
		let response = await api_methods.getVIPMeetingRooms(getters.getAccessToken,getters.getVipNo)
		if (response?.response?.code == 1) {
			return response.data.value.filter(item=>item.ID == params.roomId)[0]
		}
		return {}
	},
	async getVIPMeetingDurationsAction({ commit,state,getters},params) {
		let response = await api_methods.getVIPMeetingDurations(getters.getAccessToken,getters.getVipNo,params)
		if (response?.response?.code == 1) {
			return response.data.value
		}
		return []
	},
	async postVIPReservationRoomsAction({ commit,state,getters},params) {
		let response = await api_methods.postVIPReservationRooms(getters.getAccessToken,getters.getVipNo,params)
		if (response?.response?.code == 1) {
			return response.data.value
		}
		return -1
	},
	async getVIPReservationOrdersAction({commit,state,getters},params) {
		let response = await api_methods.getVIPReservationOrders(getters.getAccessToken,getters.getVipNo,params)
		if (response?.response?.code == 1) {
			return response.data.value
		}
		return []
	},
	async getVIPReservationCalendarAction({ commit,state,getters},params) {
		let response = await api_methods.getVIPReservationCalendar(getters.getAccessToken,getters.getVipNo,params)
		if (response?.response?.code == 1) {
			return response.data.value
		}
		return []
	},
	async getVIPReservationCartAction({ commit,state,getters},params) {
		let response = await api_methods.getVIPReservationCart(getters.getAccessToken,getters.getVipNo,params)
		if (response?.response?.code == 1) {
			return response.data.value
		}
		return {}
	},
	async getVIPReservationDetailAction({ commit,state,getters},params) { 
		let response = await api_methods.getVIPReservationDetail(getters.getAccessToken,getters.getVipNo,params)
		if (response?.response?.code == 1) {
			return response.data.value
		}
		return []
	},
	async postVIPReservationAdditionalAction({ commit,state,getters},params) { 
		let response = await api_methods.postVIPReservationAdditional(getters.getAccessToken,getters.getVipNo,params)
		if (response?.response?.code == 1) {
			return response.data.value
		}
		return []
	},
	//判断代缴账户类型
	async postVIPDeterminePaymentuserAction({ commit,state,getters},params){
		let response = await api_methods.postVIPDeterminePaymentuser(getters.getAccessToken,params.VipNo,'')
		if (response?.response?.code == 1) {
			return response.data.value
		}
		return '-1' //，默认找不到
	},
	async postVIPCancelReservationAction({ commit,state,getters},params) { 
		let response = await api_methods.postVIPCancelReservation(getters.getAccessToken,getters.getVipNo,params)
		if (response?.response?.code == 1) {
			return response.data.value
		}
		return []
	},
	async getVIPStoresAction({ commit,state,getters},params) {
		let response = await api_methods.getVIPStores(getters.getAccessToken,getters.getVipNo,params)
		if (response?.response?.code == 1) {
			commit(SETMETTINGVIPSTORES,response.data.value)
			return response.data.value
		}
		return []
	},
	async getVIPUserRankAction({commit, state, getters}) {
		let response = await api_methods.getVIPUserRank(getters.getAccessToken,getters.getVipNo)
		if (response?.response.code == 1) {
			return response
		}
		return []
	},
	async getVIPMeetingOrderTimeAction({commit,state,getters},params) {
		let response = await api_methods.getVIPMeetingOrderTime(getters.getAccessToken,getters.getVipNo,params.ParentCode,params.Code)
		if (response?.response?.code == 1) {
			return response.data.value
		}
		return []
	},
	async getVIPMeetingPointAction({commit, state, getters}) {
		let response = await api_methods.getVIPMeetingPoint(getters.getAccessToken,getters.getVipNo)
		if (response?.response.code == 1) {
			return response.data.value.point
		}
		return null
	},
	// 同订单不同时段预约单独取消
	async postVIPAloneCancelAction({ commit,state,getters},params) { 
		let response = await api_methods.postVIPAloneCancel(getters.getAccessToken,getters.getVipNo,params)
		if (response?.response?.code == 1) {
			return response.data.value
		}
		return []
	},
}